import PropTypes from 'prop-types'
import { Component } from 'react'
import { activatePage } from '../../services/optimizely/index'

class OptimizelyPage extends Component {
  componentDidMount () {
    const { pageName } = this.props
    activatePage(pageName)
  }

  // eslint-disable-next-line class-methods-use-this
  render () {
    return null
  }
}

OptimizelyPage.propTypes = {
  pageName: PropTypes.string.isRequired,
}

export default OptimizelyPage
